import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { create } from "../../api/API";
import "../../styles/LogSignup.css";
import FloatingLabelInput from "../Generic/FloatingLabelInput";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Step 1: Send reset link
  const handleSendLink = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email");

    try {
      setLoading(true);
      await create("/members/forgot-password", { email });
      toast.success("Password reset link sent! Check your email.");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Email not found. Please sign up first."
      );
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Reset password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!password || !confirmPassword) {
      return toast.error("Please fill all fields");
    }
    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      setLoading(true);
      await create(`/members/reset-password`, { token, password });
      toast.success("Password reset successful! Please login.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-page"
      style={{
        backgroundImage: `url("../assets/images/loginsignbg.png")`,
      }}
    >
      <div className="auth-box1 bg-white">
        {!token ? (
          <>
            <h2 className="auth-title text-center">Forgot Password?</h2>
            <p className="auth-subtext text-black text-center">
              Enter your email to receive a reset link.
            </p>

            <form onSubmit={handleSendLink}>
              <div className="input-wrapper bg-white">
                <FloatingLabelInput
                  label="Email*"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="auth-btn bg-primary text-white"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 className="auth-title text-center">Reset Your Password</h2>
            <p className="auth-subtext text-black text-center">
              Set a new password for your account.
            </p>

            <form onSubmit={handleResetPassword}>
              {/* New Password */}
              <div className="input-wrapper bg-white">
                <FloatingLabelInput
                  label="New Password*"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="password-icon text-black"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* Confirm Password */}
              <div className="input-wrapper bg-white">
                <FloatingLabelInput
                  label="Confirm Password*"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <span
                  className="password-icon text-black"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button
                type="submit"
                className="auth-btn bg-primary text-white"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
